<script>
import TwListGroupItem from '@/components/generic/list-group/tw-list-group-item.vue'

export default {
  name: 'DonationListGroupItemB',
  components: { TwListGroupItem },
  props: {
    donation: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <tw-list-group-item class="flex gap-4 md:gap-5 text-sm">
    <div class="min-w-16">
      <h6 :class="['p-2 bg-gray-50 rounded-md text-center', { 'blur-[2px]': donation.anonymous_amount}]">
        {{ donation.cached.amount_formatted }}
      </h6>
    </div>
    <div class="grow font-sans">
      <h6 v-if="donation.cached && donation.cached.name">
        {{ donation.cached.name }}
      </h6>
      <span v-if="donation.team" class="font-semibold"> {{ donation.team.name }} </span>
      <div v-if="donation.billing_city" class="text-xs text-gray-500">
        {{ donation.billing_city }} <span v-if="donation.billing_state">, {{ donation.billing_state }} </span>
      </div>
      <div v-if="donation.comment" class="mt-2 font-lato">
        {{ donation.comment }}
      </div>
      <div v-if="donation.fundraiser_page_id" class="text-xs mt-2">
        <span>Fundraiser: </span>
        <router-link class="text-xs text-gray-900 underline" :to="{ name: 'FundraiserPagePublicPage', params: { fundraiserPageId: donation.fundraiser_page_id, slug: donation.cached.fundraiser_page_slug } }">
          {{ donation.cached.fundraiser_page_title }}
        </router-link>
      </div>
      <div v-if="donation.created_at">
        <span class="text-xs text-gray-500"> {{ $filters.formatDateOnly(donation.created_at) }} </span>
      </div>
    </div>
  </tw-list-group-item>
</template>

<style scoped>

</style>
